var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.componentId, staticClass: "pa-2" },
    [
      [
        _c(
          "v-flex",
          [
            _c("h3", { staticClass: "mb-1" }, [_vm._v("Filtrer par...")]),
            _vm._v(" "),
            _c("v-switch", {
              staticClass: "mt-0",
              attrs: {
                color: "primary",
                label: "Motifs de clôture désactivés"
              },
              model: {
                value: _vm.disabled,
                callback: function($$v) {
                  _vm.disabled = $$v
                },
                expression: "disabled"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("v-data-table", {
          staticClass: "elevation-1",
          attrs: {
            headers: _vm.headers,
            items: _vm.closingReasons,
            loading: _vm.loading,
            "hide-actions": ""
          },
          scopedSlots: _vm._u([
            {
              key: "items",
              fn: function(props) {
                return [
                  _c("td", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(props.item.name))
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.description))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "text-xs-right pr-1" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", icon: "", small: "" },
                          on: {
                            click: function($event) {
                              _vm.edit(props.item)
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "primaryDark" } }, [
                            _vm._v("edit")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", icon: "", small: "" },
                          on: {
                            click: function($event) {
                              _vm.idToDelete = props.item.id
                              _vm.dialogDelete = true
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "primaryDark" } }, [
                            _vm._v("delete")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ])
        }),
        _vm._v(" "),
        _c(
          "v-dialog",
          {
            staticClass: "delete--dialog",
            attrs: { persistent: "", "max-width": "400" },
            model: {
              value: _vm.dialogDelete,
              callback: function($$v) {
                _vm.dialogDelete = $$v
              },
              expression: "dialogDelete"
            }
          },
          [
            _c(
              "v-card",
              { attrs: { color: "primary", dark: "" } },
              [
                _c(
                  "v-card-text",
                  { attrs: { "text-xs-left": "" } },
                  [
                    _c(
                      "v-layout",
                      {
                        staticClass: "mb-1",
                        attrs: { row: "", "align-center": "" }
                      },
                      [
                        _c(
                          "v-icon",
                          { attrs: { "x-large": "", color: "red" } },
                          [_vm._v("warning")]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "ml-4 mt-3 delete--dialog__text" },
                          [
                            _vm._v(
                              "Ce motif de clôture sera immédiatement supprimée."
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-xs-center" }, [
                      _c("b", [_vm._v("ATTENTION")]),
                      _vm._v(", cette action est irréversible !")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-divider", { attrs: { color: "white" } }),
                _vm._v(" "),
                _c(
                  "v-card-actions",
                  { staticClass: "pa-0 delete--dialog__actions" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { flat: "", color: "white" },
                        on: {
                          click: function($event) {
                            _vm.idToDelete = null
                            _vm.dialogDelete = false
                          }
                        }
                      },
                      [_vm._v("Annuler")]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: { flat: "", color: "white" },
                        on: { click: _vm.deleteItem }
                      },
                      [_vm._v("Supprimer")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35ed3199", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35ed3199","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/ticket-closing-reasons/template.html
// module id = null
// module chunks = 